/**
 * 无数据时渲染
 */

import React from 'react';
import { Menu } from '@cainiaofe/cn-ui';
export default (function (props) {
  var prefix = props.prefix,
    notFoundContent = props.notFoundContent,
    locale = props.locale;
  return /*#__PURE__*/React.createElement(Menu, {
    className: prefix + "cascader-select-not-found"
  }, /*#__PURE__*/React.createElement(Menu.Item, null, 'notFoundContent' in props ? notFoundContent : /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, locale.notFoundContent)));
});